import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M17.797 15.209 10.726 1.067a1.928 1.928 0 0 0-3.451 0L.205 15.209A1.928 1.928 0 0 0 1.93 18h14.142a1.928 1.928 0 0 0 1.725-2.791Zm-9.761-8.78a.964.964 0 0 1 1.928 0v3.857a.964.964 0 1 1-1.928 0Zm.964 9a1.286 1.286 0 1 1 1.286-1.286 1.286 1.286 0 0 1-1.281 1.286Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }